import { Link } from 'react-router-dom';

import { Button } from '@frontend/components/ui/Button';
import { EmptyState } from '@frontend/components/ui/States';

export function NotFound(): JSX.Element {
  return (
    <EmptyState
      title="That page does not exist"
      description="The link may be out of date, or the module it belonged to may have been switched off by an administrator. Nothing has been lost."
      action={
        <Link to="/">
          <Button variant="primary">Back to the dashboard</Button>
        </Link>
      }
      data-testid="not-found"
    />
  );
}
